// Is this device a phone? Decided from the User-Agent: phones announce
// "Mobi" (iPhone, Android phones, most others); Android tablets leave it
// out, and iPadOS sends a desktop Safari string — both count as tablets.
// Used where a phone behaves differently (the header's pairing icon, the
// scan camera). The games are open to phones since 2026-09-30 (spel-spec
// §19) — they used to be blocked here. Client-safe.

export function arMobiltelefon(userAgent: string | null | undefined): boolean {
  if (!userAgent) return false;
  if (/iPad|Tablet/i.test(userAgent)) return false;
  return /Mobi|iPhone|iPod|Windows Phone|BlackBerry/i.test(userAgent);
}
